import { AbstractControl, ValidationErrors } from '@angular/forms';

export class TkValidator {
  static noWhiteSpace(control: AbstractControl): ValidationErrors | null {
    if (control.value !== undefined && control.value !== null) {
      if (control.value.length === 0) {
        return null;
      } else if (control.value.toString().includes(' ')) {
        return { noWhiteSpace: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  static url(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string).length === 0) {
      return null;
    } else {
      const expression =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      const regex = new RegExp(expression);
      if ((control.value as string).match(regex)) {
        return null;
      } else {
        return { url: true };
      }
    }
    // return { url: true };
  }

  static email(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string).length === 0) {
      return null;
    } else {
      const expression = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
      const regex = new RegExp(expression);
      if ((control.value as string).match(regex)) {
        return null;
      } else {
        return { email: true };
      }
    }
  }

  static numberOnly(control: AbstractControl): ValidationErrors | null {
    if (control.value !== undefined && control.value !== null) {
      if ((control.value as string).length === 0) {
        return null;
      } else {
        if (!isNaN(control.value)) {
          return null;
        } else {
          return { numberOnly: true };
        }
      }
    } else {
      return null;
    }
  }
}
